import { IToastContext, ToastContext } from 'components/Toast/ToastContext/ToastContext';
import React, { useState, useRef, useContext } from 'react';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { StyledTextFieldContainer, StyledTextField, StyledPlaceholder, StyledErrorMessage, StyledIconContainer, StyledDropdownArrow, StyledTextArea, StyledCharCounter, StyledTextAreaContainer } from './TextField.styled';

interface ITextFieldProps {
  onChange: (newValue: string) => void;
  placeholder: string;
  maxCharacters?: number;
  initialValue?: string;
  disabled?: boolean;

}

export const TextArea: React.FC<ITextFieldProps> = ({ initialValue, placeholder = '', onChange, maxCharacters, disabled = false, ...rest }) => {
  const [value, setValue] = useState(initialValue || '');
  const inputRef: React.RefObject<HTMLTextAreaElement> = useRef(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <StyledTextAreaContainer {...rest}>
      <StyledTextArea
        maxLength={maxCharacters}
        value={value}
        ref={inputRef}
        onChange={handleChange}
        placeholder={placeholder}
      />
      {maxCharacters && <StyledCharCounter>{value.length}/{maxCharacters}</StyledCharCounter>}
    </StyledTextAreaContainer>
  );
};
